import { lazy } from 'react';
import { closeModal, ComponentDataType, isModalOpened, openModal } from '@/utils/modals';
import { PrintPreviewModalProps } from '@/features/PrintingDocuments/components/PrintPreviewModal/types';
import { PrintPreviewReportProps } from '@/features/PrintingDocuments/components/PrintPreviewReport/types';
import { PrintPreviewReturnLabelProps } from '@/features/PrintingDocuments/components/PrintPreviewReturnLabel/types';

export const SchedulePickMultiLocationModal = lazy(
  () => import('@/pages/pickups/components/SchedulePickupMultiLocationModal')
);

export const PreviewPackingSlipModal = lazy(() => import('@/components/PreviewPackingSlipModal'));
export const PrintPreviewModal = lazy(
  () => import('@/features/PrintingDocuments/components/PrintPreviewModal')
);

export const PrintingPreviewReport = lazy(
  () => import('@/features/PrintingDocuments/components/PrintPreviewReport')
);

export const PrintingPreviewReturnLabel = lazy(
  () => import('@/features/PrintingDocuments/components/PrintPreviewReturnLabel')
);

export enum MODAL {
  SCHEDULE_PICK_UP = 'SCHEDULE_PICK_UP',
  PREVIEW_PACKING_SLIP = 'PREVIEW_PACKING_SLIP',
}

export const closeModalPrintPreview = () => {
  closeModal(PrintPreviewModal);
};
export const isOpenedModalPrintPreview = () => isModalOpened(PrintPreviewModal);

export const openModalPrintPreview = (props: PrintPreviewModalProps) =>
  openModal(PrintPreviewModal, props);

export const openPrintingPreviewReport = (props: PrintPreviewReportProps) =>
  openModal(PrintingPreviewReport, props);

export const openPrintingPreviewReturnLabel = (props: PrintPreviewReturnLabelProps) =>
  openModal(PrintingPreviewReturnLabel, props);

export const openModalAngular = (modalName: MODAL, data?: ComponentDataType) => {
  switch (modalName) {
    case MODAL.SCHEDULE_PICK_UP:
      return openModal(SchedulePickMultiLocationModal, data);

    case MODAL.PREVIEW_PACKING_SLIP:
      return openModal(PreviewPackingSlipModal, data);

    default:
      /** no any */
      return null;
  }
};
